import React, { type FC } from 'react'

import { Flex } from 'mailup-web-components'

import IconStarSolid from 'Components/icons/IconStarSolid'

const iconProps = {
  width: '15px',
  height: '15px',
  fill: '#e9e9e9',
}

const stars = Array.from({ length: 3 })

const EngagementUpsellingView: FC = () => {
  return (
    <Flex display="inline-flex" alignItems="center" height="20px">
      {stars.map((_, i) => (
        <IconStarSolid key={i} {...iconProps} />
      ))}
    </Flex>
  )
}

export default EngagementUpsellingView
